import React, {useCallback, useEffect, useMemo} from 'react';

import {Analytics} from '@buncha/config/analytics/analytics';
import AppModal from '@buncha/common/components/CustomModal/AppModal';
import {ModalDetails} from '@buncha/onBoarding/types';
import {useAppSelector} from '@buncha/config/redux/hooks';

interface Props {
  open: boolean;
  topCTAHandler: () => void;
  bottomCTAHandler: () => void;
  expectedBarcode: string;
  scannedBarcode: string;
  itemId: number | undefined;
  itemName: string | undefined;
  orderId: number | undefined;
  runId: number | undefined;
  orderItemIds?: number[];
}

const NSCSkipModal = (props: Props) => {
  const {
    open,
    expectedBarcode,
    scannedBarcode,
    itemName,
    itemId,
    orderId,
    runId,
    orderItemIds,
  } = props;
  const ALLOW_SHOPPER_NON_NSC_ITEM_MODAL = useAppSelector(
    gState => gState.onboarding.constants?.ALLOW_SHOPPER_NON_NSC_ITEM_MODAL,
  );
  const shopperName = useAppSelector(
    gState => gState.onboarding.currentUser?.firstName,
  );

  const modalData = useMemo(() => {
    let modalDetails: ModalDetails | null;
    try {
      modalDetails = JSON.parse(ALLOW_SHOPPER_NON_NSC_ITEM_MODAL ?? '{}');
    } catch {
      modalDetails = {};
    }

    return modalDetails;
  }, [ALLOW_SHOPPER_NON_NSC_ITEM_MODAL]);

  const subheader = useMemo(() => {
    let text =
      modalData?.subheader?.replace?.(':expectedBarcode:', expectedBarcode) ??
      '';
    text = text.replace('"scannedBarcode:', scannedBarcode);

    return text;
  }, [expectedBarcode, modalData?.subheader, scannedBarcode]);

  const analyticData = useMemo(
    () => ({
      catalogItemId: itemId,
      orderId,
      itemName,
      shopperName: shopperName,
      runId,
      orderItemIds,
    }),
    [itemId, itemName, orderId, orderItemIds, runId, shopperName],
  );

  const topCTAHandler = useCallback(() => {
    Analytics.eventWithProps(
      'Meijer - Barcode validation: Rescan',
      analyticData,
    );
    props.topCTAHandler();
  }, [analyticData, props]);

  const bottomCTAHandler = useCallback(() => {
    Analytics.eventWithProps(
      'Meijer - Barcode validation: Bypass',
      analyticData,
    );
    props.bottomCTAHandler();
  }, [analyticData, props]);

  useEffect(() => {
    if (!open) return;

    Analytics.eventWithProps('Meijer - Barcode validation', analyticData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return <></>;

  return (
    <AppModal
      isOpen={open}
      ctaTopTitle={modalData?.topCTA ?? ''}
      ctaBottomTitle={modalData?.bottomCTA}
      // eslint-disable-next-line no-empty-function
      onClose={() => {}}
      title={modalData?.header ?? ''}
      subTitle={subheader}
      topCTAHandelr={topCTAHandler}
      bottomCTAHandelr={bottomCTAHandler}
    />
  );
};

export default React.memo(NSCSkipModal);
